"use strict";
// _partialFile.js

{
  window.addEventListener("DOMContentLoaded", function () {
    const options = {
      scrollHintIconAppendClass: "scroll-hint-icon-black",
      i18n: {
        scrollable: "スクロールできます",
      },
    };

    // 画面幅が768px以下（SP）の場合のみScrollHintを有効化
    if (window.matchMedia("(max-width: 768px)").matches) {
      new ScrollHint(".js-scrollable", options);
    }

    // 画面幅が1179px以下の場合のみScrollHintを有効化
    if (window.matchMedia("(max-width: 1179px)").matches) {
      new ScrollHint(".js-scrollable2", options);
    }
  });
}
